if (!customElements.get('form-launch-countdown')) {
  customElements.define('form-launch-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.clock = this.querySelector('[role="timer"]');
      this.finished = this.querySelector('[role="status"]');
      const launchAt = this.dataset.launchAt || '';
      // Require an explicit offset so every visitor counts down to the same instant.
      this.deadline = /T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(launchAt)
        ? Date.parse(launchAt) : NaN;
      if (!this.clock || !this.finished) return;
      this.finished.hidden = true;
      if (!Number.isFinite(this.deadline)) {
        this.clock.hidden = true;
        return;
      }
      this.parts = ['days', 'hours', 'minutes', 'seconds'].map(part => this.querySelector(`[data-${part}]`));
      if (this.parts.some(part => !part)) return;
      if (this.update()) this.interval = setInterval(() => this.update(), 1000);
    }

    update() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      this.parts.forEach((part, index) => { part.textContent = String(values[index]).padStart(2, '0'); });
      this.clock.hidden = remaining === 0;
      this.finished.hidden = remaining !== 0;
      if (remaining === 0) this.stop();
      return remaining > 0;
    }

    stop() { clearInterval(this.interval); this.interval = null; }
    disconnectedCallback() { this.stop(); }
  });
}
